var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeading1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#464646",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.923 16V6.9H7.301V10.8H11.708V6.9H13.086V16H11.708V11.931H7.301V16H5.923ZM15.8727 16V8.46L14.4037 8.798V7.784L16.4187 6.9H17.3027V16H15.8727Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading1);
export default __webpack_public_path__ + "static/media/heading_1.f078977085243e20232c5b159eb9c0d6.svg";
export { ForwardRef as ReactComponent };